import { isEqual } from "lodash";

import AppLink from "@components/link/link";
import { classNames } from "@helpers/css";

const tabClassName =
  "text-gray-400 font-medium py-2 text-sm border-b-2 border-transparent shrink-0 flex-nowrap";

const Tabs = <T,>({
  options,
  selectedValue,
  onClickOptionValue,
  className = "",
}: {
  options: {
    value: T;
    label: string;
    to?: string;
  }[];
  selectedValue: T;
  onClickOptionValue?: (value: T) => void;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "flex items-center gap-8 border-b overflow-x-auto flex-nowrap",
        className,
      )}
    >
      {options.map(({ value, label, to }) =>
        to ? (
          <AppLink
            key={label}
            className={classNames(
              tabClassName,
              isEqual(value, selectedValue)
                ? "border-blue-link text-blue-link hover:text-blue-link"
                : " hover:text-gray-700 hover:border-gray-200",
            )}
            to={to}
            onClick={() => onClickOptionValue?.(value)}
          >
            {label}
          </AppLink>
        ) : (
          <button
            key={label}
            className={classNames(
              tabClassName,
              isEqual(value, selectedValue)
                ? "border-blue-link text-blue-link hover:text-blue-link"
                : " hover:text-gray-700 hover:border-gray-200",
            )}
            aria-label={label}
            onClick={() => onClickOptionValue?.(value)}
          >
            {label}
          </button>
        ),
      )}
      <div className={classNames(tabClassName, "flex-1")}>&nbsp;</div>
    </div>
  );
};

export default Tabs;
